import { forwardRef, memo, useEffect, useState } from "react";
import { BzTab, BzTabs } from "../../../../components";


const CustomDropdownToggle = forwardRef(({ children, onClick }, ref) => (
    <div
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </div>
));

const OrdersTabs = ({ arrPlaceOrderInfo, activeTabKey, children, setActiveTabKey }) => {

    const [activeKabab, setActiveKabab] = useState([]);

    const arrOrdersKababDropdown = [
        { id: '0', value: 'all_order_report', content: 'All Order Report', },
    ];

    const arrPositionsKababDropdown = [
        { id: '0', value: 'net_position_report', content: 'Net Position Report', },
        { id: '1', value: 'position_summary', content: 'Position Summary', },
    ];


    useEffect(() => {
        if (activeTabKey === 'orders') {
            setActiveKabab(arrOrdersKababDropdown);
        } else if (activeTabKey === 'positions') {
            setActiveKabab(arrPositionsKababDropdown);
        } else { setActiveKabab([]); }
    }, [activeTabKey]);

    

    return (
        <div className=''>
            <BzTabs className='nav nav-tabs horizontal-scroll-wrap'>
                {arrPlaceOrderInfo?.map((eachTab) => (
                    <BzTab className='nav-link text-capitalize' key={eachTab.tabKey} tabKey={eachTab.scrip} isActive={eachTab.tabKey === activeTabKey} onClick={() => setActiveTabKey(eachTab.tabKey)}>
                        <div className='d-flex align-items-center gap-2'>
                            {eachTab.scrip}
                            {activeTabKey === eachTab.tabKey ?
                                <>
                                    <div className='clear-background me-2'>
                                        {/* Hari K:08-01-2024: BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings – NSE EQ not required as of now*/}
                                        {/* <div className='icon-14 icon-kebab icon-dark icon-faded'></div> */}
                                        {/* <Dropdown className='dropdown-kebab'>
                                            <Dropdown.Toggle className='icon-10 icon-kebab icon-dark'>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {
                                                    activeKabab && activeKabab.map((eachOption) => (
                                                        eachOption && <Dropdown.Item key={eachOption.id} value={eachOption.value} onClick={() => kababDropdownoptionsOnClickHandler(eachOption.value)}>
                                                            <Container fluid className='p-0'>
                                                                <Row className='g-0' >
                                                                    <Col md={12} className='d-flex justify-content-start align-self-center'>
                                                                        <div className='text-nowrap text-truncate'>{eachOption?.content}</div>
                                                                    </Col>
                                                                </Row>
                                                            </Container>
                                                        </Dropdown.Item>
                                                    ))
                                                }
                                            </Dropdown.Menu>
                                        </Dropdown> */}
                                        {/* <TabsMenus >
                                        </TabsMenus> */}
                                    </div>
                                </>
                                : null}
                        </div>
                    </BzTab>
                ))}
            </BzTabs>
        </div>
    );
};

export default memo(OrdersTabs);